import React, { useEffect, useState, Fragment, memo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import OutsideAlerter from 'b2b-ui-components-lib/lib/components/outsideAlerter';
import { OvRejection } from 'home/view/upgrade-order/components/common/OvRejection';
import {
  aehKycLoginAsync,
  updateOrderAsync,
  createLeadAsync,
  aehLoginAsync,
  getLeadAsync,
  validateLeadAsync,
  createOrderAsync,
  fetchOrderAsync,
  submitOrderAsync,
  cancelLeadAsync,
  cancelOrderAsync,
  checkFeasibilityAsync,
  submitLeadAsync,
  kamSubmitLeadAsync,
  updateLeadAsync,
  doaSubmitClarityAsync,
  needAssistanceAsync,
  checkFeasibilityShiftingAsync
} from 'home/view/upgrade-order/services';
import {
  getErrMsg,
  getProductName,
  getSource,
  getOrderType,
  getLeadStatus,
  getOrderSubType,
  yearToMonths,
  monthsToYear,
  numberWithCommas,
  prepareRequestForKAM,
  useInterval,
  getPlanPrice,
  getPlanDetail,
  getHardwareType,
  getContractPeriod,
  clearSessionData,
  hasValidMediaAndSiteDetails,
  hasValidMediaAndSiteSpecs,
  fsProceedBtnOnClick,
  fsCancelOrderOnClick,
  getOldLineItemDetail,
  getServiceType,
  getCurrentBw
} from 'home/view/upgrade-order/utils';
import {
  SESSION_STORAGE,
  TOAST_TYPE,
  USER_TYPE,
  LEAD_STATUS,
  ORDER_STATUS,
  HARDWARE_TYPE,
  FIELD_ERROR,
  ACTIVE_TABS,
  SERVICE_TYPE,
  CALLBACK_DELAY,
  MEDIA_TYPES
} from 'home/view/upgrade-order/constants';
import { getRequestForOrderUpdate } from 'home/view/upgrade-order/utils';

import { CONTEXT } from 'home/view/upgrade-order/context';

import CustomModal from 'home/view/upgrade-order/components/common/CustomModal';
import EmailPopup from 'home/view/upgrade-order/components/common/EmailPopup';
// import OrderKycComponent from 'home/view/upgrade-order/components/accordions/OrderKycComponent';
// import ThankYouPage from 'home/view/upgrade-order/components/common/ThankYouPage';

import {
  findParamFromUrl,
  getFromSessionStorage,
  setInSessionStorage,
  removeFromSessionStorage,
  setMetaTags,
  isDevEnv,
  isAuthForDev,
  getNotificationType,
  isFormTouched,
  scrollToTop,
  removeUserSessionData
} from 'common/utils/app.utils';

import { JOURNEY_TYPE, META_TAGS, ORDER_TYPE, ROUTES, STORAGE_KEY, TYPEOF_ORDER, isShiftingJourney } from 'common/constants/app.constants';

import './index.scss';

import LoaderComponent from 'home/view/upgrade-order/components/common/LoaderComponent';
import FooterComponent from 'home/view/upgrade-order/components/common/FooterComponent';
import CancelModal from 'home/view/upgrade-order/components/common/CancelModal';
import CustomerJourney from './CustomerJourney';
import KamJourney from './KamJourney';
import { getDoaStatus } from '../utils';
import { DOA_STATUS } from '../constants/common-constants';
import { getCurrentLead, getFeasibilityStaus, saveLead } from 'tokenGeneration/lead.util';
import { Notification } from 'featureLib/NotificationComponent';
import StepsHeader from 'home/components/functional/steps-header/steps.component';
import { DEDICATED_FEASIBILITY_DATA, MODULE_ID } from 'home/common/constants/constants';
import { getRequestForBillingandShippingUpdate } from 'home/view/upgrade-order/utils/common-utils';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';
import { validateTokenForOrder } from 'common/services/http.service';
import { NOTIFICATION_MESSAGE } from 'home/view/manage-feasibility/constants';
import { FEASBILITY_MESSAGE } from 'singleSite/feasibility-id/feasibility-constants';

const TOAST_DEFAULT = {
  show: false,
  message: '',
  type: '',
  closeToastTime: '8000'
};

const SingleSiteUpgrade = memo(() => {
  const [leadData, setLeadData] = useState({});
  const [orderDetail, setOrderDetail] = useState({});
  const [isOrderLoaded, setIsOrderLoaded] = useState(false);
  const [userType, setUserType] = useState('');
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [pnqToken, setPnqToken] = useState('');
  const [kycToken, setKycToken] = useState('');
  // const [confirmPricingPopup, setConfirmPricingPopup] = useState(false);
  const [confirmPricingKamPopup, setConfirmPricingKamPopup] = useState(false);
  const [confirmOrderPopup, setConfirmOrderPopup] = useState(false);
  const [showNeedAssistPopup, setShowNeedAssistPopup] = useState(false);
  const [submitOrderPopup, setShowSubmitOrderPopup] = useState(false);
  const [submitShiftingOrderPopup, setSubmitShiftingOrderPopup] = useState(false);
  const [isOrderConfirmation, setIsOrderConfirmation] = useState(isOrderConfirmationUrl());
  const [showThankYouPage, setShowThankYouPage] = useState(false);
  const [showCancelPage, setShowCancelPage] = useState(false);

  const [loading, setLoading] = useState(false);
  const [formStatus, setFormStatus] = useState({
    purchaseDetail: false,
    billingDetails: false,
    shippingDetails: false
  });
  const [formData, setFormData] = useState({
    purchaseDetail: null,
    billingDetails: null,
    shippingDetails: null
  });
  const [pnqFormOpen, setIsPnqFormOpen] = useState(false);
  const [poFormOpen, setPoFormOpen] = useState(false);
  const [errors, setErrors] = useState({
    email: [],
    phoneNumber: [],
    siteContactName: [FIELD_ERROR.REQUIRED],
    siteContactNumber: [FIELD_ERROR.REQUIRED],
    siteContactEmail: [FIELD_ERROR.REQUIRED],
    cpe: [FIELD_ERROR.REQUIRED],
    cpeSpecification: [FIELD_ERROR.REQUIRED],
    rentalCost: [FIELD_ERROR.REQUIRED],
    otcCost: [FIELD_ERROR.REQUIRED],
    clarityRequired: [FIELD_ERROR.REQUIRED],
    upgradeFormBwChanged: false,
    upgradeFormMediaChanged: false,
    upgradeFormServiceTypeChanged: false,
    upgradeFormContactChanged: false,
    upgradeFormAuthorisedSignatoryChanged: false,
    upgradeFormHardwareDetailsChanged: false
  });
  const [blockJourney, setBlockJourney] = useState(false);
  const [lowerPriceBw, setLowerPriceBw] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);

  // upgrade details form
  const [contactList, setContactList] = useState([]);
  const [selectedContact, setSelectedContact] = useState({});
  const [siteInCharge, setSiteInCharge] = useState({});
  const [selectedHardwareType, setSelectedHardwareType] = useState({});
  const [selectedBandwidth, setSelectedBandwidth] = useState({});
  const [selectedServiceType, setSelectedServiceType] = useState({});
  const [selectedPrimaryMedia, setSelectedPrimaryMedia] = useState({});
  const [selectedCpe, setSelectedCpe] = useState({});
  const [selectedCpeSpecification, setSelectedCpeSpecification] = useState({});

  // pricing form - customer + kam
  const [selectedContractPeriod, setSelectedContractPeriod] = useState({});
  const [activeTab, setActiveTab] = useState(ACTIVE_TABS.STANDARD_PRICE);
  const [rentalCost, setRentalCost] = useState('');
  const [otcCost, setOtcCost] = useState('');
  const [commentText, setCommentText] = useState('');
  const [attachments, setAttachment] = useState(null);
  const [activeStep, setActiveStep] = useState(2);
  const [toast, setToast] = useState(TOAST_DEFAULT);
  const [showBillingDetails, setShowBillingDetails] = useState(false);

  const params = {
    lsi: findParamFromUrl('lsi'),
    partyId: findParamFromUrl('partyId'),
    platform: findParamFromUrl('platform'),
    source: findParamFromUrl('platform'),
    leadId: findParamFromUrl('leadId'),
    orderId: findParamFromUrl('orderId'),
    userType: findParamFromUrl('userType') ?? findParamFromUrl('user'),
    journey: findParamFromUrl('journey'),
    authTokenFromUrl: findParamFromUrl('auth', false),
    orderType: findParamFromUrl('type', false)
  };

  const accessToken = localStorage.getItem('accessToken');

  const history = useHistory();

  const showNotificationForSentEmail = ({ orderStatus, ocLinkSentAtList }) => {
    const ocLinkSentAt = ocLinkSentAtList?.join(', ').toString();

    const EmailSentmessage = (
      <p>
        Order confirmation link has been sent to <a href="javascript:void(0)"> {ocLinkSentAt}</a> to{' '}
        <a href="javascript:void(0)" role="button" onClick={() => setSubmitShiftingOrderPopup(true)} style={{ textDecoration: 'underline' }}>
          Confirm Order.
        </a>
      </p>
    );
    const verifierMessage = (
      <p>
        To verify the order click on{' '}
        <a href="javascript:void(0)" role="button" onClick={() => setSubmitShiftingOrderPopup(true)} style={{ textDecoration: 'underline' }}>
          Confirm Order.
        </a>
      </p>
    );
    const toastMsg = isOrderConfirmation && isOrderConfirmationUrl() ? verifierMessage : EmailSentmessage;
    setToastMsg(true, toastMsg, TOAST_TYPE.ORDER_CONFIRMATION);
  };

  useEffect(() => {
    const upgradePageMeta = {
      ...META_TAGS.B2B_HOME,
      title: META_TAGS.B2B_PRICING_QUOTATION.TITLE.UPGRADE
    };

    setMetaTags(upgradePageMeta);
    getLead();
  }, []);

  useEffect(() => {
    if (orderDetail.orderStatus === ORDER_STATUS.OV_REJECTED) {
      window.scrollTo(0, 0);
    }

    if (orderDetail.orderStatus === ORDER_TYPE.ORDER_CONFIRMATION_PENDING) {
      showNotificationForSentEmail(orderDetail);
    }
  }, [orderDetail]);

  useEffect(() => {
    if (getCurrentLead()?.leadId) {
      updateActiveStep();
    }
  }, [getCurrentLead()?.leadId]);

  useEffect(() => {
    scrollToTop();
  }, [loading]);

  const updateActiveStep = () => {
    const savedLead = getCurrentLead();
    const leadStatus = savedLead.leadStatus;
    const isFeasibilityCheck = leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS || leadStatus === LEAD_STATUS.FEASIBILITY_PENDING || leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE;
    const isPlanAndConfig =
      leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED ||
      leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION ||
      leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT ||
      leadStatus === LEAD_STATUS.PRICING_DOA_APPROVED ||
      leadStatus === LEAD_STATUS.PRICING_DOA_REJECTED;

    const isConfirmOrderDetails = leadStatus === LEAD_STATUS.LEAD_SUBMITTED || leadStatus === LEAD_STATUS.KYC_IN_PROGRESS || leadStatus === LEAD_STATUS.KYC_SUBMITTED;

    let activeStep = 1;

    if (isFeasibilityCheck) {
      activeStep = 2;
    }
    if (isPlanAndConfig) {
      activeStep = 3;
    }
    if (isConfirmOrderDetails) {
      activeStep = 4;
    }

    setActiveStep(activeStep);
  };

  // const fetchOrderDetailsFromConfirmationLink = async () => {
  //   const postData = {
  //     aehAccessToken: accessToken,
  //     partyId: params.partyId
  //   };

  //   setLoading(true);
  //   postData['orderId'] = params.orderId;
  //   const { res, err } = await aehKycLoginAsync(postData);
  //   const _authorization = (await (res && res.headers && res.headers.authorization)) || (res && res.headers && res.headers.Authorization);

  //   if (err) {
  //     const errorMsg = getErrMsg(err);
  //     setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
  //     setLoading(false);
  //     throw new Error(errorMsg);
  //   }

  //   setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN, _authorization);

  //   setKycToken(_authorization);
  //   fetchOrder(_authorization);
  //   setLoading(false);
  // };

  const handleOrderConfirmationUrl = () => {
    setLoading(true);
    validateTokenForOrder(params.authTokenFromUrl, params.orderType, params.orderId).then(
      (response) => {
        setLoading(false);
        fetchOrder(params.authTokenFromUrl);
        // fetchOrderDetailsFromConfirmationLink();
      },
      (err) => {
        setLoading(false);
        removeUserSessionData();
        history.push(ROUTES.B2B_FAILURE);
      }
    );
  };

  const getLead = () => {
    const leadToken = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PNQ_AUTH_TOKEN);
    const orderToken = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN);
    const lsiId = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.LSI_ID) || '';
    const partyId = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PARTY_ID) || '';

    const hasLsiOrPartyIdChanged = () => {
      const lsiChanged = lsiId.toString() !== params.lsi;
      const partyIdChanged = partyId.toString() !== params.partyId;

      return lsiChanged || partyIdChanged;
    };

    const fetchSameLead = !hasLsiOrPartyIdChanged() && (leadToken || orderToken);

    if (params.authTokenFromUrl && params.orderId && params.orderType === ORDER_TYPE.ORDER_CONFIRMATION) {
      handleOrderConfirmationUrl();
    } else if (params.leadId || params.orderId) {
      loginAeh();
    } else if (fetchSameLead) {
      if (leadToken) {
        fetchLead(leadToken);
        setPnqToken(leadToken);
      }
      if (orderToken) {
        fetchOrder(orderToken);
        setKycToken(orderToken);
      }
    } else {
      fetchPnQLeadForValidation();
    }
  };

  const redirectToCommonAcqPage = () => {
    let redirectURL = ROUTES.DEDICATED_HOME;

    if (params?.partyId) {
      redirectURL = redirectURL + `?partyId=${params.partyId}`;
    }
    if (params?.lsi) {
      redirectURL = redirectURL + `&lsi=${params.lsi}`;
    }
    if (params?.platform) {
      redirectURL = redirectURL + `&platform=${params.platform || 'AEH'}`;
    }
    if (params?.journey) {
      redirectURL = redirectURL + `&journey=${params.journey}`;
    }

    if (isDevEnv() && isAuthForDev()) {
      redirectURL = redirectURL + `&isAuth=${findParamFromUrl('isAuth', false)}`;
    }

    history?.push(redirectURL);
  };

  const fetchPnQLeadForValidation = async () => {
    try {
      setLoading(true);
      const payload = {
        lsi: params.lsi,
        partyId: params.partyId,
        platform: 'AEH',
        source: 'AEH',
        orderSubType: isShiftingJourney() ? TYPEOF_ORDER.SHIFTING : TYPEOF_ORDER.UPGRADE
      };

      const { res, err } = await validateLeadAsync(payload);
      const result = await (res && res.data && res.data.result);
      const authorization = await ((res && res.headers && res.headers.Authorization) || (res && res.headers && res.headers.authorization));
      const userType = await ((res && res.headers && res.headers.userType) || (res && res.headers && res.headers.usertype));

      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        throw new Error(errorMsg);
      }

      if (result && Object.keys(result).length > 0 && authorization && userType) {
        const leadStatus = result && result.leadStatus;

        setLeadData(result);
        setUserType(userType);

        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PNQ_AUTH_TOKEN, authorization);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.USER_TYPE, userType);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PARTY_ID, params.partyId);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.LSI_ID, params.lsi);
        setInSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE, JOURNEY_TYPE.SINGLE_UPGRADE);

        setPnqToken(authorization);
        setUserType(userType);
        setLeadData(result);
        saveLead(result);
        setLoading(false);

        // redirect to thank you for kyc submitted
        userType === USER_TYPE.CUSTOMER && leadStatus === LEAD_STATUS.KYC_SUBMITTED ? setShowThankYouPage(true) : setShowThankYouPage(false);
        leadStatus === LEAD_STATUS.LEAD_CANCELLED || leadStatus === LEAD_STATUS.ORDER_CANCELLED ? setShowCancelPage(true) : setShowCancelPage(false);
      } else {
        redirectToCommonAcqPage();
      }
    } catch (e) {
      console?.error(e);
    }
  };

  const loginAeh = async () => {
    try {
      setLoading(true);
      const postData = {
        aehAccessToken: accessToken,
        partyId: params.partyId
      };

      if (params.leadId) {
        postData['leadId'] = params.leadId;
        const { res, err } = await aehLoginAsync(postData);
        const authorization = (await (res && res.headers && res.headers.authorization)) || (res && res.headers && res.headers.Authorization);
        const userType = await ((res && res.headers && res.headers.userType) || (res && res.headers && res.headers.usertype) || params.userType);

        if (authorization) {
          setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PNQ_AUTH_TOKEN, authorization);
          setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.USER_TYPE, userType);
          setUserType(userType);
          setPnqToken(authorization);

          fetchLead(authorization);
        }

        if (err) {
          const errorMsg = getErrMsg(err);
          setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
          setLoading(false);
          throw new Error(errorMsg);
        }
        if (authorization && params.orderId) {
          setLoading(true);
          delete postData['leadId'];
          postData['orderId'] = params.orderId;
          const { res, err } = await aehKycLoginAsync(postData);
          const _authorization = (await (res && res.headers && res.headers.authorization)) || (res && res.headers && res.headers.Authorization);

          if (err) {
            const errorMsg = getErrMsg(err);
            setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
            setLoading(false);
            throw new Error(errorMsg);
          }

          setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN, _authorization);

          setKycToken(_authorization);
          fetchOrder(_authorization);
          setLoading(false);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const checkOrderConfirmationStatus = ({ orderStatus }) => {
    const status = (orderStatus && [ORDER_TYPE.ORDER_CONFIRMATION, ORDER_TYPE.ORDER_CONFIRMATION_PENDING]).includes(orderStatus) || isOrderConfirmationUrl();
    setIsOrderConfirmation(status);
  };

  const fetchOrder = async (order_token, cb) => {
    try {
      setLoading(true);
      const { res, err } = await fetchOrderAsync(order_token);
      const result = await (res && res.data && res.data.result);
      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        setIsOrderLoaded(false);
        throw new Error(errorMsg);
      }

      // if (isOrderConfirmationUrl()) {
      //   const leadId = result?.lead?.leadId;
      //   const postData = {
      //     aehAccessToken: accessToken,
      //     partyId: params.partyId
      //   };
      //   postData['leadId'] = leadId;
      //   const { res, err } = await aehLoginAsync(postData);
      //   const authorization = (await (res && res.headers && res.headers.authorization)) || (res && res.headers && res.headers.Authorization);
      //   const userType = await ((res && res.headers && res.headers.userType) || (res && res.headers && res.headers.usertype) || params.userType);

      //   if (authorization) {
      //     setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PNQ_AUTH_TOKEN, authorization);
      //     setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.USER_TYPE, userType);
      //     setUserType(userType);
      //     setPnqToken(authorization);

      //     fetchLead(authorization);
      //   }

      //   if (err) {
      //     const errorMsg = getErrMsg(err);
      //     setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
      //     setLoading(false);
      //     throw new Error(errorMsg);
      //   }
      // }

      if (result && result.orderId) {
        if (result.orderStatus === ORDER_STATUS.OV_REJECTED) {
          setShowThankYouPage(false);
        }
        // setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.ORDER_DETAILS, result);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.ORDER_ID, result.orderId);
        setIsOrderLoaded(true);
        setOrderDetail(result);
        checkOrderConfirmationStatus(result);
        setLoading(false);
        cb?.();
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleOrderSubmit = async (successCb = null) => {
    try {
      const payload = getRequestForBillingandShippingUpdate(formData, orderDetail);

      const { res, err } = await updateOrderAsync(payload, kycToken);
      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        throw new Error(errorMsg);
      }

      if (res) {
        // submitOrder();
        successCb?.();
      }
    } catch (e) {
      console.error(e);
    }
  };

  const submitOrder = async () => {
    setShowSubmitOrderPopup(false);
    try {
      setLoading(true);
      const { res, err } = await submitOrderAsync(kycToken || params.authTokenFromUrl);

      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        throw new Error(errorMsg);
      }

      if (res) {
        const { data: { success = false } = {} } = res;

        if (success) {
          const orderToken = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN) || params.authTokenFromUrl;
          const authorization = kycToken ? kycToken : orderToken;
          const submitCb = () => {
            setShowThankYouPage(true);
          };

          fetchOrder(authorization, submitCb);
          // immediately fetching lead after submit order is not giving updated lead status.
          // setTimeout(() => {
          //   fetchLead(pnqToken, true);
          // }, 2000);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchLead = async (token, isSubmitOrder = false, isCancelOrder = false) => {
    try {
      setLoading(true);

      const { res, err } = await getLeadAsync(token);
      const result = await (res && res.data && res.data.result);
      const userType = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.USER_TYPE) || params.userType;

      if (err) {
        const errorMsg = getErrMsg(err);
        setLoading(false);

        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        throw new Error(errorMsg);
      }

      if (result) {
        const leadStatus = result && result.leadStatus;
        setLeadData(result);
        saveLead(result);
        if (isSubmitOrder) {
          setShowSubmitOrderPopup(false);
        }

        if (isCancelOrder) {
          setShowCancelPopup(false);
        }

        if (!isSubmitOrder && !isCancelOrder) {
          setUserType(userType);
          setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.USER_TYPE, userType);
          setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PARTY_ID, params.partyId);
          setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.LSI_ID, params.lsi);
          setInSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE, JOURNEY_TYPE.SINGLE_UPGRADE);
        }

        setLoading(false);
        // redirect to thank you for kyc submitted
        userType === USER_TYPE.CUSTOMER && leadStatus === LEAD_STATUS.KYC_SUBMITTED ? setShowThankYouPage(true) : setShowThankYouPage(false);
        leadStatus === LEAD_STATUS.LEAD_CANCELLED || leadStatus === LEAD_STATUS.ORDER_CANCELLED ? setShowCancelPage(true) : setShowCancelPage(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const cbInterval = () => {
    return (leadData && leadData.doaStatus) !== DOA_STATUS.IN_PROGRESS ? null : CALLBACK_DELAY;
  };

  // poll fetch lead in case of doaStatus - in progress
  useInterval(fetchLead, cbInterval());

  const createLead = async () => {
    try {
      setLoading(true);
      const postData = {
        lsi: params.lsi,
        partyId: params.partyId,
        platform: params.platform,
        source: params.source
      };
      const { res, err } = await createLeadAsync(postData);
      const result = await (res && res.data && res.data.result);
      const authorization = await ((res && res.headers && res.headers.Authorization) || (res && res.headers && res.headers.authorization));
      const userType = await ((res && res.headers && res.headers.userType) || (res && res.headers && res.headers.usertype));

      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        throw new Error(errorMsg);
      }

      if (authorization && userType) {
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PNQ_AUTH_TOKEN, authorization);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.USER_TYPE, userType);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PARTY_ID, params.partyId);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.LSI_ID, params.lsi);

        removeFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN);

        removeFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.SITE_IN_CHARGE);

        setKycToken('');

        setPnqToken(authorization);
        setUserType(userType);
        setLeadData(result);
        saveLead(result);
        setLoading(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const cancelPnQLead = async (remarks) => {
    try {
      setLoading(true);
      const { res, err } = await cancelLeadAsync({ remarks }, pnqToken);
      const success = await (res && res.data && res.data.success);
      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        throw new Error(errorMsg);
      }
      if (success) {
        fetchLead(pnqToken, false, true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleCancelClick = async (remarks) => {
    setShowCancelPopup(false);
    const leadStatus = getLeadStatus(leadData);
    switch (leadStatus) {
      case LEAD_STATUS.LEAD_IN_PROGRESS:
      case LEAD_STATUS.FEASIBILITY_COMPLETED:
      case LEAD_STATUS.LEAD_SUBMITTED:
      case LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION:
      case LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT: {
        cancelPnQLead(remarks);
        break;
      }
      case LEAD_STATUS.KYC_IN_PROGRESS: {
        try {
          setLoading(true);
          const { res, err } = await cancelOrderAsync({ remarks }, kycToken);
          const success = await (res && res.data && res.data.success);
          if (err) {
            const errorMsg = getErrMsg(err);
            setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
            setLoading(false);
            throw new Error(errorMsg);
          }
          if (success) {
            fetchLead(pnqToken, false, true);
          }
        } catch (e) {
          console.error(e);
        }
        break;
      }
      default: {
        return () => {};
      }
    }
  };
  const onProcceedClick = () => {
    if (formData && formData.purchaseDetail && Object.keys(formData.purchaseDetail).length > 0) {
      updateOrder(formData.purchaseDetail, true, true, true);
    } else {
      onSubmitClick();
    }
  };
  const updateOrder = async (form = null, isPurchaseForm = false, isPOChecked = false, isSubmit = false) => {
    try {
      const currentFormData = formData && formData.purchaseDetail ? formData : form;
      let updatedFormData = { ...currentFormData };

      if (form && isPurchaseForm) {
        updatedFormData = {
          ...updatedFormData,
          purchaseDetail: form
        };
      }

      const orderRequest = getRequestForOrderUpdate({ ...updatedFormData }, orderDetail, isPurchaseForm, isPOChecked);
      if (orderRequest) {
        const { res, err } = await updateOrderAsync(orderRequest, kycToken);
        if (isSubmit && res && res.data && res.data.success) {
          onSubmitClick();
        }
        if (err) {
          const errorMsg = getErrMsg(err);
          setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
          throw new Error(errorMsg);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getOrderCustomMsg = () => {
    const rental = getPlanPrice(leadData) && getPlanPrice(leadData).rental;
    const oneTimeCharge = getPlanPrice(leadData) && getPlanPrice(leadData).oneTimeCharge;
    const contractPeriod = (selectedContractPeriod && selectedContractPeriod.key) || (getContractPeriod(leadData) && monthsToYear(getContractPeriod(leadData)));

    const totalSum = rental * contractPeriod + oneTimeCharge;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: 10,
          lineHeight: 1.5,
          color: '#555A5A',
          fontWeight: 'normal'
        }}
      >
        <span
          className="sub-title"
          style={{
            fontSize: 14,
            fontWeight: 400
          }}
        >
          Do you want to confirm the price: <span style={{ color: '#cc000a' }}>Total Contract Value: &#8377; {numberWithCommas(totalSum)}</span> and proceed to the next step ?
        </span>
      </div>
    );
  };

  const getFeasibilityCustomMsg = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: 10,
          lineHeight: 1.5,
          color: '#555A5A',
          fontWeight: 'normal'
        }}
      >
        <span
          className="sub-title"
          style={{
            fontSize: 16,
            fontWeight: 600
          }}
        >
          Address can not be updated once feasibility has been performed.
        </span>
      </div>
    );
  };

  const getPricingCustomMsg = () => {
    let rental = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.charge;

    let standardRate = (selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.standardRate) || false;

    const isNonStandardHardware = (selectedHardwareType && selectedHardwareType.id === HARDWARE_TYPE.NON_STANDARD) || false;

    const isZeroRateCard = parseInt(rental) === 0 && !standardRate;

    const isSelectedMediaOffnetOrThirdParty =
      selectedPrimaryMedia &&
      selectedPrimaryMedia.hasOwnProperty('key') &&
      (selectedPrimaryMedia.key === MEDIA_TYPES.OFFNET || selectedPrimaryMedia.key === MEDIA_TYPES.THIRD_PARTY);

    if (isNonStandardHardware || isZeroRateCard || isSelectedMediaOffnetOrThirdParty) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingBottom: 10,
            lineHeight: 1.5,
            color: '#555A5A',
            fontWeight: 'normal'
          }}
        >
          <span
            className="sub-title"
            style={{
              fontSize: 16,
              fontWeight: 600
            }}
          >
            Please note that the selected plan with non-standard Hardware/Bandwidth will be submitted to the account manager for the pricing review. You will be notified with the
            finalised pricing within 24hrs. Do you want to proceed with this plan?
          </span>
        </div>
      );
    }

    if (lowerPriceBw) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingBottom: 10,
            lineHeight: 1.5,
            color: '#555A5A',
            fontWeight: 'normal'
          }}
        >
          <span
            className="sub-title"
            style={{
              fontSize: 16,
              fontWeight: 600
            }}
          >
            Please note that the selected plan will be submitted to the account manager for the pricing review. You will be notified with the finalised pricing within 24hrs. Do you
            want to proceed with this plan?
          </span>
        </div>
      );
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: 10,
          lineHeight: 1.5,
          color: '#555A5A',
          fontWeight: 'normal'
        }}
      >
        <span
          className="sub-title"
          style={{
            fontSize: 16,
            fontWeight: 600
          }}
        >
          Proceeding to Pricing Quotation will block from any further change. Are you sure you want to proceed to the Pricing Quotation ?
        </span>
      </div>
    );
  };

  const getPricingkamCustomMsg = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: 10,
          lineHeight: 1.5,
          color: '#555A5A',
          fontWeight: 'normal'
        }}
      >
        <span
          className="sub-title"
          style={{
            fontSize: 16,
            fontWeight: 600
          }}
        >
          {` The above ${activeTab === ACTIVE_TABS.CUSTOM_PRICE ? 'customized' : ''} price quote is going to be submitted to the
          Delegation of Authority for approval. Are you sure you want to submit
          the ${activeTab === ACTIVE_TABS.CUSTOM_PRICE ? 'customized' : ''} price ?`}
        </span>
      </div>
    );
  };

  const getUpdatedLeadData = () => {
    let leadDataCopy = JSON.parse(JSON.stringify(leadData));

    if (
      Object.keys(selectedContact).length > 0 &&
      leadDataCopy.customer &&
      Array.isArray(leadDataCopy.customer.customerContacts) &&
      leadDataCopy.customer.customerContacts.length > 0
    ) {
      leadDataCopy.customer.customerContacts = contactList;
    }

    // update Site In Charge
    if (
      Object.keys(siteInCharge).length > 0 &&
      Array.isArray(leadDataCopy.lineItems) &&
      leadDataCopy.lineItems.length > 0 &&
      leadDataCopy.lineItems[0].plan &&
      Array.isArray(leadDataCopy.lineItems[0].plan.site) &&
      leadDataCopy.lineItems[0].plan.site.length > 0 &&
      leadDataCopy.lineItems[0].plan.site[0]
    ) {
      leadDataCopy.lineItems[0].plan.site[0].siteIncharge = siteInCharge;
    }

    // bandwidth and pricing update
    if (
      selectedBandwidth &&
      Object.keys(selectedBandwidth).length > 0 &&
      Array.isArray(leadDataCopy.lineItems) &&
      leadDataCopy.lineItems.length > 0 &&
      leadDataCopy.lineItems[0].plan &&
      leadDataCopy.lineItems[0].plan.bandwidth &&
      leadDataCopy.lineItems[0].plan.price
    ) {
      leadDataCopy.lineItems[0].plan.bandwidth = selectedBandwidth.key;

      if (userType === USER_TYPE.CUSTOMER) {
        let rentalCost = '';
        let otcCost = '';
        let standardRate = false;

        if (selectedBandwidth && selectedBandwidth.key && leadDataCopy.leadStatus !== LEAD_STATUS.PRICING_DOA_APPROVED) {
          rentalCost = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.charge;
          otcCost = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.otc;
          standardRate = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.standardRate;
        } else {
          rentalCost = getPlanPrice(leadData) && getPlanPrice(leadData).rental;
          otcCost = getPlanPrice(leadData) && getPlanPrice(leadData).oneTimeCharge;
          standardRate = getPlanDetail(leadData) && getPlanDetail(leadData).standardRate;
        }

        leadDataCopy.lineItems[0].plan = {
          ...leadDataCopy.lineItems[0].plan,
          standardRate
        };

        leadDataCopy.lineItems[0].plan = {
          ...leadDataCopy.lineItems[0].plan,
          standardRate,
          price: {
            ...leadDataCopy.lineItems[0].plan.price,
            rental: rentalCost,
            oneTimeCharge: otcCost,
            customPricePlan: false
          }
        };
      }
    }

    // update service type
    if (Object.keys(selectedServiceType).length > 0 && Array.isArray(leadDataCopy.lineItems) && leadDataCopy.lineItems.length > 0 && leadDataCopy.lineItems[0].subProductName) {
      leadDataCopy.lineItems[0].subProductName = selectedServiceType.key;
    }

    // update cpe details
    if (
      Object.keys(selectedCpe).length > 0 &&
      Array.isArray(leadDataCopy.lineItems) &&
      leadDataCopy.lineItems.length > 0 &&
      leadDataCopy.lineItems[0] &&
      leadDataCopy.lineItems[0].plan &&
      Array.isArray(leadDataCopy.lineItems[0].plan.specs) &&
      leadDataCopy.lineItems[0].plan.specs.length > 0
    ) {
      leadDataCopy.lineItems[0].plan.specs[0].value = selectedServiceType.key === SERVICE_TYPE.UNMANAGED ? 'None' : selectedCpe.key;
      leadDataCopy.lineItems[0].plan.specs[0].commercial = selectedHardwareType.id === HARDWARE_TYPE.NON_STANDARD;
    } else {
      const hasCpeSpec =
        Array.isArray(leadDataCopy.lineItems) &&
        leadDataCopy.lineItems.length > 0 &&
        leadDataCopy.lineItems[0] &&
        leadDataCopy.lineItems[0].plan &&
        Array.isArray(leadDataCopy.lineItems[0].plan.specs) &&
        leadDataCopy.lineItems[0].plan.specs.find((item) => item.name === 'cpe');

      if (
        Array.isArray(leadDataCopy.lineItems) &&
        leadDataCopy.lineItems.length > 0 &&
        leadDataCopy.lineItems[0] &&
        leadDataCopy.lineItems[0].plan &&
        leadDataCopy.lineItems[0].plan
      ) {
        if (hasCpeSpec) {
          leadDataCopy.lineItems[0].plan.specs.find((item) => item.name === 'cpe').value = selectedServiceType.key === SERVICE_TYPE.UNMANAGED ? 'None' : selectedCpe.key;
        } else {
          leadDataCopy.lineItems[0].plan.specs = [
            {
              name: 'cpe',
              value: selectedServiceType.key === SERVICE_TYPE.UNMANAGED ? 'None' : selectedCpe.key,
              commercial: selectedHardwareType.id === HARDWARE_TYPE.NON_STANDARD
            }
          ];
        }
      }
    }

    // update cpe specification details
    if (
      Object.keys(selectedCpeSpecification).length > 0 &&
      Array.isArray(leadDataCopy.lineItems) &&
      leadDataCopy.lineItems.length > 0 &&
      leadDataCopy.lineItems[0] &&
      leadDataCopy.lineItems[0].plan &&
      Array.isArray(leadDataCopy.lineItems[0].plan.site) &&
      leadDataCopy.lineItems[0].plan.site.length > 0 &&
      leadDataCopy.lineItems[0].plan.site[0] &&
      Array.isArray(leadDataCopy.lineItems[0].plan.site[0].siteSpecs) &&
      leadDataCopy.lineItems[0].plan.site[0].siteSpecs.length > 0
    ) {
      const hasCpeSpecs = leadDataCopy.lineItems[0].plan.site[0].siteSpecs.some((item) => item.name === 'cpeSpecification');

      if (hasCpeSpecs) {
        leadDataCopy.lineItems[0].plan.site[0].siteSpecs.map((item) => {
          if (item.name === 'cpeSpecification') {
            item.value = selectedServiceType.key === SERVICE_TYPE.UNMANAGED ? 'None' : selectedCpeSpecification.key;
            item.commercial = selectedHardwareType.id === HARDWARE_TYPE.NON_STANDARD;
          }

          return item;
        });
      } else {
        leadDataCopy.lineItems[0].plan.site[0].siteSpecs.push({
          name: 'cpeSpecification',
          value: selectedServiceType.key === SERVICE_TYPE.UNMANAGED ? 'None' : selectedCpeSpecification.key,
          commercial: selectedHardwareType.id === HARDWARE_TYPE.NON_STANDARD
        });
      }
    } else {
      const hasCpeSpec =
        Array.isArray(leadDataCopy.lineItems) &&
        leadDataCopy.lineItems.length > 0 &&
        leadDataCopy.lineItems[0] &&
        leadDataCopy.lineItems[0].plan &&
        Array.isArray(leadDataCopy.lineItems[0].plan.site) &&
        leadDataCopy.lineItems[0].plan.site.length > 0 &&
        leadDataCopy.lineItems[0].plan.site[0] &&
        Array.isArray(leadDataCopy.lineItems[0].plan.site[0].siteSpecs) &&
        leadDataCopy.lineItems[0].plan.site[0].siteSpecs.find((item) => item.name === 'cpeSpecification');

      if (
        Array.isArray(leadDataCopy.lineItems) &&
        leadDataCopy.lineItems.length > 0 &&
        leadDataCopy.lineItems[0] &&
        leadDataCopy.lineItems[0].plan &&
        Array.isArray(leadDataCopy.lineItems[0].plan.site) &&
        leadDataCopy.lineItems[0].plan.site.length > 0 &&
        leadDataCopy.lineItems[0].plan.site[0]
      ) {
        if (hasCpeSpec) {
          leadDataCopy.lineItems[0].plan.site[0].siteSpecs.find((item) => item.name === 'cpeSpecification').value =
            selectedServiceType.key === SERVICE_TYPE.UNMANAGED ? 'None' : selectedCpeSpecification.key;
        } else {
          leadDataCopy.lineItems[0].plan.site[0].siteSpecs = [
            {
              name: 'cpeSpecification',
              value: selectedServiceType.key === SERVICE_TYPE.UNMANAGED ? 'None' : selectedCpeSpecification.key,
              commercial: selectedHardwareType.id === HARDWARE_TYPE.NON_STANDARD
            }
          ];
        }
      }
    }

    // update Contract Period
    const contractPeriodInMonths = yearToMonths(selectedContractPeriod.key);
    if (
      Object.keys(selectedContractPeriod).length > 0 &&
      leadDataCopy.contractPeriod &&
      Array.isArray(leadDataCopy.lineItems) &&
      leadDataCopy.lineItems.length > 0 &&
      leadDataCopy.lineItems[0] &&
      leadDataCopy.lineItems[0].contractPeriod
    ) {
      leadDataCopy.contractPeriod = contractPeriodInMonths;
      leadDataCopy.lineItems[0].contractPeriod = contractPeriodInMonths;
    }

    // update custom price - KAM
    if (
      userType === USER_TYPE.KAM &&
      rentalCost &&
      Array.isArray(leadDataCopy.lineItems) &&
      leadDataCopy.lineItems.length > 0 &&
      leadDataCopy.lineItems[0] &&
      leadDataCopy.lineItems[0].plan &&
      leadDataCopy.lineItems[0].plan.price
    ) {
      leadDataCopy.lineItems[0].plan.price.rental = rentalCost;
      leadDataCopy.lineItems[0].plan.price.oneTimeCharge = otcCost;
      leadDataCopy.lineItems[0].plan.standardRate = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.standardRate;

      if (activeTab === ACTIVE_TABS.STANDARD_PRICE) {
        leadDataCopy.lineItems[0].plan.price.customPricePlan = false;
      } else {
        leadDataCopy.lineItems[0].plan.price.customPricePlan = true;
      }
    }

    // update selected media in siteSpecs
    if (hasValidMediaAndSiteSpecs({ selectedPrimaryMedia, leadDataCopy })) {
      const hasMediaItem = leadDataCopy.lineItems[0].plan.site[0].siteSpecs.some((item) => item.name === 'media');

      if (hasMediaItem) {
        leadDataCopy.lineItems[0].plan.site[0].siteSpecs.map((item) => {
          if (item.name === 'media') {
            item.value = (selectedPrimaryMedia && selectedPrimaryMedia.key) || '';
            item.commercial = selectedHardwareType.id === HARDWARE_TYPE.NON_STANDARD;
          }

          return item;
        });
      } else {
        leadDataCopy.lineItems[0].plan.site[0].siteSpecs.push({
          name: 'media',
          value: (selectedPrimaryMedia && selectedPrimaryMedia.key) || '',
          commercial: selectedHardwareType.id === HARDWARE_TYPE.NON_STANDARD
        });
      }
    }
    // update selected media in selectedMedia key
    if (hasValidMediaAndSiteDetails({ selectedPrimaryMedia, leadDataCopy })) {
      const selectedMedia = [];

      selectedMedia.push({
        media: selectedPrimaryMedia.key,
        primary: true
      });

      leadDataCopy.lineItems[0].plan.site[0]['selectedMedia'] = selectedMedia;
    }

    return leadDataCopy;
  };

  const checkFeasibility = async () => {
    try {
      setLoading(true);
      const updatedLeadData = getUpdatedLeadData();
      const { res, err } = await checkFeasibilityAsync(updatedLeadData, pnqToken);
      const result = await (res && res.data && res.data.result);
      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        throw new Error(errorMsg);
      }

      if (result) {
        setLeadData(result);
        saveLead(result);
        setLoading(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const checkShiftingFeasibility = async (feasibilityResponse, isAddFeasibilityId = false) => {
    try {
      const updatedLeadData = getUpdatedLeadData();
      const maxFeasibleBandwidth = feasibilityResponse?.maxBandwidth;
      const existingBandwidth = getOldLineItemDetail(updatedLeadData)?.bandwidth && getOldLineItemDetail(updatedLeadData)?.bandwidth?.split(' ');

      if (isAddFeasibilityId && parseInt(existingBandwidth) > maxFeasibleBandwidth) {
        setToastMsg(true, FEASBILITY_MESSAGE.MAX_BANDWIDTH_ERROR, TOAST_TYPE.ERROR);
        scrollToTop();
        return;
      }

      const savedFeasibilityResponse = feasibilityResponse ?? getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_DATA);
      const payload = updatedLeadData;
      const params = {
        feasibilityId: savedFeasibilityResponse.feasibilityId,
        // pnqId: updatedLeadData.pricingAndQuotationId,
        lineItemIndex: 0,
        siteIndex: 0
      };
      const { res, err } = await checkFeasibilityShiftingAsync(payload, params, pnqToken);
      const result = await (res && res.data && res.data.result);
      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        throw new Error(errorMsg);
      }
      if (result) {
        let feasibilityStaus = getFeasibilityStaus(result);
        if (feasibilityStaus === LEAD_STATUS.PENDING) {
          const leadToken = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PNQ_AUTH_TOKEN);
          fetchLead(pnqToken || leadToken);
        }
        //updateLead();
        setLeadData(result);
        saveLead(result);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const setToastMsg = (show, message, type) => {
    setToast({ show, message, type });
  };

  const updateLead = async () => {
    try {
      setLoading(true);
      let updatedLeadData = getUpdatedLeadData();
      const { res, err } = await updateLeadAsync(updatedLeadData, pnqToken);
      const result = await (res && res.data && res.data.result);
      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        // setConfirmPricingPopup(false);
        throw new Error(errorMsg);
      }
      setLeadData(result);
      saveLead(result);
      // setConfirmPricingPopup(false);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  const submitLeadCustomer = async () => {
    try {
      setLoading(true);
      let updatedLeadData = getUpdatedLeadData();
      const { res, err } = await submitLeadAsync(updatedLeadData, pnqToken);
      const result = await (res && res.data && res.data.result);
      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        throw new Error(errorMsg);
      }
      if (result && result.leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
        createOrder();
      } else {
        fetchLead(pnqToken);
        setLoading(false);
      }
    } catch (e) {
      console.error('Issue while submitting lead - Customer..');
    }
  };

  const submitLeadKam = async () => {
    try {
      setLoading(true);
      let updatedLeadData = getUpdatedLeadData();
      const { res, err } = await kamSubmitLeadAsync(updatedLeadData, pnqToken);
      const result = await (res && res.data && res.data.result);
      if (err) {
        const errorMsg = getErrMsg(err);
        // setLeadData(updatedLeadData);
        // saveLead(result);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        throw new Error(errorMsg);
      }
      result && result.leadStatus && fetchLead(pnqToken);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  const submitClarity = async () => {
    let updatedLeadData = getUpdatedLeadData();
    const request = prepareRequestForKAM(updatedLeadData, {
      commentText,
      attachments,
      userType
    });
    try {
      const { res, err } = await doaSubmitClarityAsync(request, pnqToken);
      const result = await (res && res.data && res.data.result);
      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        throw new Error(errorMsg);
      }
      result && result.leadStatus && fetchLead(pnqToken);
    } catch (e) {
      console.error(e);
    }
  };
  const handleConfirmPricing = () => {
    // setConfirmPricingPopup(false);

    const {
      upgradeFormBwChanged,
      upgradeFormMediaChanged,
      upgradeFormServiceTypeChanged,
      upgradeFormContactChanged,
      upgradeFormAuthorisedSignatoryChanged,
      upgradeFormHardwareDetailsChanged
    } = errors;
    const hasFormChanged =
      upgradeFormBwChanged ||
      upgradeFormMediaChanged ||
      upgradeFormServiceTypeChanged ||
      upgradeFormContactChanged ||
      upgradeFormAuthorisedSignatoryChanged ||
      upgradeFormHardwareDetailsChanged;

    let updatedLeadData = getUpdatedLeadData();

    const isRentalZero = () => {
      const rental = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.charge;

      return parseInt(rental) === 0 ? true : false;
    };

    const isStandardRate = () => {
      return (selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.standardRate) || false;
    };

    const isNonStandardHardware = () => {
      const hardwareType = getHardwareType(updatedLeadData);

      if (hardwareType) {
        return hardwareType === HARDWARE_TYPE.NON_STANDARD;
      }

      return false;
    };

    const isZeroRateCard = () => {
      return isRentalZero() && !isStandardRate();
    };

    if (pnqFormOpen && (isNonStandardHardware() || isZeroRateCard() || lowerPriceBw)) {
      if (isNonStandardHardware() || isZeroRateCard()) {
        submitLeadCustomer();
      } else if (lowerPriceBw) {
        const remarks = 'The Annual Recurring Cost for the upgraded bandwidth is less than the current running Annual Recurring Cost.';
        handleNeedAssistSubmit(remarks);
      }
    } else if (hasFormChanged) {
      updateLead();
    }
  };

  const handleConfirmPricingKam = () => {
    setConfirmPricingKamPopup(false);
    const doaStatus = getDoaStatus(leadData);

    if (doaStatus === DOA_STATUS.CLARITY_REQUIRED || doaStatus === DOA_STATUS.IN_PROGRESS) {
      submitClarity();
    } else {
      submitLeadKam();
    }
  };

  const handleConfirmOrder = async () => {
    setConfirmOrderPopup(false);
    const leadStatus = getLeadStatus(leadData);
    if (userType === USER_TYPE.CUSTOMER && leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED) {
      submitLeadCustomer();
    }
    if (userType === USER_TYPE.CUSTOMER && leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
      createOrder();
    }
  };

  const handleNeedAssistSubmit = async (remarks) => {
    try {
      setShowNeedAssistPopup(false);
      setLoading(true);
      let updatedLeadData = getUpdatedLeadData();
      const { res, err } = await updateLeadAsync(updatedLeadData, pnqToken);
      const result = await (res && res.data && res.data.result);
      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        throw new Error(errorMsg);
      }

      if (result && result.leadStatus) {
        const { res, err } = await needAssistanceAsync({ remarks }, pnqToken, userType);
        const success = await (res && res.data && res.data.success);
        if (err) {
          const errorMsg = getErrMsg(err);
          setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
          setLoading(false);
          throw new Error(errorMsg);
        }

        if (success) {
          setLoading(false);
          fetchLead(pnqToken);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const createOrder = async () => {
    try {
      setLoading(true);
      let updatedLeadData = getUpdatedLeadData();
      const payload = {
        orderSource: getSource(updatedLeadData),
        orderType: getOrderType(updatedLeadData),
        serviceType: getProductName(updatedLeadData) === 'INTERNET' ? 'DEDICATED_INTERNET' : 'VPN',
        orderSubType: getOrderSubType(updatedLeadData)
      };

      const { res, err } = await createOrderAsync(payload, pnqToken);
      const authorization = await (res && res.headers && res.headers.authorization);
      const result = await (res && res.data && res.data.result);

      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setLoading(false);
        throw new Error(errorMsg);
      }

      if (result && authorization) {
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN, authorization);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.ORDER_ID, result.orderId);

        setKycToken(authorization);
        fetchLead(pnqToken);
        fetchOrder(authorization);
        setLoading(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleOutsideClick = () => {
    // clearing session data on clicking outside of OTP modal.
    // clearSessionData();
  };

  const noAddressSelectedForShifting = () => {
    const leadStatus = getLeadStatus(getUpdatedLeadData());
    const shiftingFeasibilityData = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_DATA);

    return leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS && !shiftingFeasibilityData;
  };

  const showFooter = () => {
    if (isShiftingJourney() && noAddressSelectedForShifting()) {
      return false;
    }

    // if ((isOrderConfirmation || isOrderConfirmationUrl()) && !showThankYouPage) {
    //   return true;
    // }

    if (orderDetail.orderStatus === ORDER_STATUS.OV_REJECTED) {
      return true;
    }
    return !showThankYouPage && !showCancelPage;
  };

  const checkErrors = () => {
    const errorCopy = { ...errors };
    const doaStatus = getUpdatedLeadData()?.doaStatus;

    if (userType === USER_TYPE.CUSTOMER || !pnqFormOpen || (userType === USER_TYPE.KAM && activeTab === ACTIVE_TABS.STANDARD_PRICE)) {
      errorCopy.rentalCost = [];
      errorCopy.otcCost = [];
      errorCopy.clarityRequired = [];
    }

    if (userType === USER_TYPE.KAM && activeTab === ACTIVE_TABS.CUSTOM_PRICE && !doaStatus) {
      errorCopy.clarityRequired = [];
    }

    if (selectedServiceType && selectedServiceType.key !== SERVICE_TYPE.MANAGED) {
      errorCopy.cpe = [];
      errorCopy.cpeSpecification = [];
    }

    let hasError = false;

    Object.entries(errorCopy).forEach(([key, value]) => {
      if (key && value && value.length > 0) {
        hasError = true;
      }
    });

    return hasError;
  };

  const onSubmitClick = async () => {
    // if (isShiftingJourney() && (isOrderConfirmation || isOrderConfirmationUrl())) {
    //   setSubmitShiftingOrderPopup(true);
    // }

    setSubmitClicked(true);
    const hasFormError = checkErrors();
    const leadStatus = getLeadStatus(getUpdatedLeadData());

    if (!hasFormError) {
      fsProceedBtnOnClick(leadData, userType);
      switch (leadStatus) {
        case LEAD_STATUS.LEAD_IN_PROGRESS: {
          checkFeasibility();
          break;
        }
        case LEAD_STATUS.FEASIBILITY_COMPLETED: {
          const isNonStandardHardware = () => {
            const hardwareType = getHardwareType(getUpdatedLeadData());

            if (hardwareType) {
              return hardwareType === HARDWARE_TYPE.NON_STANDARD;
            }

            return false;
          };

          if (userType === USER_TYPE.CUSTOMER) {
            if (pnqFormOpen && !isNonStandardHardware() && !lowerPriceBw) {
              setConfirmOrderPopup(true);
            } else {
              // setConfirmPricingPopup(true);
              handleConfirmPricing();
            }
          } else {
            if (pnqFormOpen) {
              setConfirmPricingKamPopup(true);
            } else {
              // setConfirmPricingPopup(true);
              handleConfirmPricing();
            }
          }
          break;
        }
        case LEAD_STATUS.LEAD_SUBMITTED: {
          setConfirmOrderPopup(true);
          break;
        }
        case LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION:
        case LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT: {
          if (pnqFormOpen) {
            setConfirmPricingKamPopup(true);
          } else {
            // setConfirmPricingPopup(true);
            handleConfirmPricing();
          }
          break;
        }
        case LEAD_STATUS.KYC_IN_PROGRESS: {
          if (isShiftingJourney()) {
            const isPOFormValid = !showBillingDetails && formStatus.purchaseDetail;
            const isBillingFormValid = showBillingDetails && formStatus.billingDetails && formStatus.shippingDetails;

            if (isPOFormValid) {
              updateOrder(null, true, true);
              setShowBillingDetails(true);
            } else if (isBillingFormValid) {
              const successCb = () => {
                setSubmitShiftingOrderPopup(true);
              };
              // setShowSubmitOrderPopup(true);
              if (!(isOrderConfirmation || isOrderConfirmationUrl())) {
                handleOrderSubmit(successCb);
              } else {
                successCb();
              }
            }
          } else {
            setShowSubmitOrderPopup(true);
          }
          break;
        }

        case LEAD_STATUS.KYC_SUBMITTED: {
          if (orderDetail.orderStatus === ORDER_STATUS.OV_REJECTED) {
            if (isShiftingJourney()) {
              const isPOFormValid = !showBillingDetails && formStatus.purchaseDetail;
              const isBillingFormValid = showBillingDetails && formStatus.billingDetails && formStatus.shippingDetails;

              if (isPOFormValid) {
                updateOrder(null, true, true);
                setShowBillingDetails(true);
              } else if (isBillingFormValid) {
                const successCb = () => {
                  setSubmitShiftingOrderPopup(true);
                };
                // setShowSubmitOrderPopup(true);
                if (!(isOrderConfirmation || isOrderConfirmationUrl())) {
                  handleOrderSubmit(successCb);
                } else {
                  successCb();
                }
              }
            } else {
              setShowSubmitOrderPopup(true);
            }
          }
          break;
        }

        default: {
          return () => {};
        }
      }
    }
  };

  const onCancelClick = () => {
    setShowCancelPopup(true);
    fsCancelOrderOnClick(getUpdatedLeadData(), userType);
  };

  const isSubmitDisabled = useCallback(() => {
    const leadStatus = getLeadStatus(getUpdatedLeadData());
    const doaStatus = getUpdatedLeadData()?.doaStatus;
    const oldBwArr = getOldLineItemDetail(getUpdatedLeadData?.())?.bandwidth && getOldLineItemDetail(getUpdatedLeadData?.())?.bandwidth?.split(' ');
    const oldBwValue = (Array.isArray(oldBwArr) && oldBwArr?.length > 0 && oldBwArr?.[0]) ?? '';
    const newBwValue = getCurrentBw(getUpdatedLeadData?.())?.value;
    const oldSubProductName = getOldLineItemDetail(getUpdatedLeadData?.())?.subProductName;
    const newSubProductName = getServiceType(getUpdatedLeadData?.());

    const isBwUpgradedSameAsOld = parseInt(newBwValue) === parseInt(Number(oldBwValue));
    const isSubProductNameSameAsOld = newSubProductName === oldSubProductName;

    if (
      !isShiftingJourney() &&
      (!leadStatus ||
        (userType === USER_TYPE.CUSTOMER && leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED && isBwUpgradedSameAsOld) ||
        (userType === USER_TYPE.KAM && leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION && isBwUpgradedSameAsOld))
    ) {
      return true;
    }

    // if (isShiftingJourney() && (isOrderConfirmation || isOrderConfirmationUrl())) {
    //   return false;
    // }

    const hasFormError = checkErrors();

    const { upgradeFormBwChanged, upgradeFormMediaChanged, upgradeFormServiceTypeChanged, upgradeFormHardwareDetailsChanged, upgradeFormAuthorisedSignatoryChanged } = errors;

    const isLeadUpdatedAfterFeasibility = leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED && (upgradeFormHardwareDetailsChanged || upgradeFormAuthorisedSignatoryChanged);

    const upgradeFieldsUpdated = upgradeFormBwChanged || upgradeFormMediaChanged || upgradeFormServiceTypeChanged || isLeadUpdatedAfterFeasibility;

    const isLeadInProgress = () => {
      return (
        leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS ||
        leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED ||
        leadStatus === LEAD_STATUS.LEAD_SUBMITTED ||
        leadStatus === LEAD_STATUS.KYC_IN_PROGRESS
      );
    };

    const isRentalZero = () => {
      const rental = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.charge;

      return parseInt(rental) === 0 ? true : false;
    };

    const isStandardRate = () => {
      return (selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.standardRate) || false;
    };

    const isNonStandardHardware = () => {
      const hardwareType = getHardwareType(getUpdatedLeadData());

      if (hardwareType) {
        return !isLeadInProgress() && hardwareType === HARDWARE_TYPE.NON_STANDARD;
      }

      return false;
    };

    const isZeroRateCard = () => {
      return !isLeadInProgress() && isRentalZero() && !isStandardRate();
    };

    const isUpgradeFieldsUpdated = () => {
      if (isShiftingJourney()) {
        return false;
      }

      return !pnqFormOpen && !poFormOpen && !upgradeFieldsUpdated;
    };

    const isPOFormValid = !showBillingDetails && formStatus.purchaseDetail;
    const isBillingFormValid = showBillingDetails && formStatus.billingDetails && formStatus.shippingDetails;
    if (userType === USER_TYPE.CUSTOMER) {
      return (
        hasFormError ||
        isNonStandardHardware() ||
        isZeroRateCard() ||
        blockJourney ||
        isUpgradeFieldsUpdated() ||
        leadStatus === LEAD_STATUS.FEASIBILITY_PENDING ||
        leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE ||
        leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION ||
        leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT ||
        leadStatus === LEAD_STATUS.PRICING_DOA_REJECTED ||
        (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS && !(isPOFormValid || isBillingFormValid)) ||
        (leadStatus === LEAD_STATUS.KYC_SUBMITTED && orderDetail.orderStatus === ORDER_STATUS.OV_REJECTED && !(isPOFormValid || isBillingFormValid))
      );
    }
    if (userType === USER_TYPE.KAM) {
      return (
        hasFormError ||
        (pnqFormOpen && activeTab === ACTIVE_TABS.STANDARD_PRICE && (isZeroRateCard() || lowerPriceBw)) ||
        isUpgradeFieldsUpdated() ||
        leadStatus === LEAD_STATUS.PRICING_DOA_APPROVED ||
        leadStatus === LEAD_STATUS.PRICING_DOA_REJECTED ||
        leadStatus === LEAD_STATUS.FEASIBILITY_PENDING ||
        leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE ||
        leadStatus === LEAD_STATUS.LEAD_SUBMITTED ||
        leadStatus === LEAD_STATUS.KYC_IN_PROGRESS ||
        leadStatus === LEAD_STATUS.KYC_SUBMITTED ||
        (leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT && doaStatus !== DOA_STATUS.CLARITY_REQUIRED)
      );
    }
  }, [userType, errors, formStatus, showBillingDetails, orderDetail.orderStatus]);

  const isCancelDisabled = () => {
    const leadStatus = getLeadStatus(getUpdatedLeadData());
    const doaStatus = getUpdatedLeadData()?.doaStatus;

    if (!leadStatus) {
      return true;
    }

    if (userType === USER_TYPE.CUSTOMER) {
      return (
        loading ||
        leadStatus === LEAD_STATUS.FEASIBILITY_PENDING ||
        leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE ||
        leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION ||
        leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT ||
        leadStatus === LEAD_STATUS.KYC_SUBMITTED
      );
    }
    if (userType === USER_TYPE.KAM) {
      return (
        loading ||
        leadStatus === LEAD_STATUS.FEASIBILITY_PENDING ||
        leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE ||
        leadStatus === LEAD_STATUS.LEAD_SUBMITTED ||
        leadStatus === LEAD_STATUS.PRICING_DOA_REJECTED ||
        leadStatus === LEAD_STATUS.KYC_SUBMITTED ||
        (leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT && doaStatus !== DOA_STATUS.CLARITY_REQUIRED)
      );
    }
  };

  return (
    <Fragment>
      {showThankYouPage || showCancelPage ? null : (
        <section className="stepper">
          <StepsHeader
            hideBackBtn={true}
            activeStepIndex={activeStep}
            isdedicatedJourney={true}
            isUnAuthJourney={false}
            skipNetworkstatus={true}
            isMultiSite={true}
            showTrackBtn={true}
          />
        </section>
      )}
      {showThankYouPage || showCancelPage ? null : (
        <section id="notification" className="notification notification_single_upgrade">
          <Notification
            show={toast.show}
            type={getNotificationType(toast.type)}
            message={toast.message}
            eventHandler={() => setToast(TOAST_DEFAULT)}
            onCancel={() => setToast(TOAST_DEFAULT)}
          ></Notification>
        </section>
      )}
      <CONTEXT.Provider
        value={{
          params,
          userType,
          setToastMsg,
          setLoading,
          history,
          pnqToken,
          kycToken,
          setKycToken,
          setPnqToken,
          loading
        }}
      >
        <OutsideAlerter onOutsideClick={handleOutsideClick}>
          <div className="single-site-upgrade">
            {showCancelPopup && <CancelModal setshowPopup={setShowCancelPopup} onSubmit={handleCancelClick} loading={loading} leadData={leadData} />}
            {/* {confirmPricingPopup && (
              <CustomModal
                customPopupTitle="Proceed to Price Quotation"
                customPopupMsg={getPricingCustomMsg()}
                submitCustomPopup={handleConfirmPricing}
                closeCustomPopup={() => setConfirmPricingPopup(false)}
                loading={loading}
                leadData={leadData}
              />
            )} */}
            {confirmPricingKamPopup && (
              <CustomModal
                customPopupTitle={activeTab === ACTIVE_TABS.STANDARD_PRICE ? 'Submit Standard Pricing for Approval' : 'Submit Customized Price for Approval'}
                customPopupMsg={getPricingkamCustomMsg()}
                submitCustomPopup={handleConfirmPricingKam}
                closeCustomPopup={() => setConfirmPricingKamPopup(false)}
                loading={loading}
                leadData={leadData}
              />
            )}
            {confirmOrderPopup && (
              <CustomModal
                customPopupTitle="Confirm Pricing"
                customPopupMsg={getOrderCustomMsg()}
                submitCustomPopup={handleConfirmOrder}
                closeCustomPopup={() => setConfirmOrderPopup(false)}
                loading={loading}
                leadData={leadData}
              />
            )}
            {submitOrderPopup && (
              <CustomModal
                submitOrderPopup
                customPopupTitle="Confirm Order"
                customPopupMsg="Are you sure you want to place the order?"
                submitCustomPopup={() => {
                  if (isShiftingJourney()) {
                    handleOrderSubmit();
                  } else {
                    submitOrder();
                  }
                }}
                closeCustomPopup={() => setShowSubmitOrderPopup(false)}
                leadData={leadData}
              />
            )}
            {submitShiftingOrderPopup && (
              <EmailPopup
                // setNotification={setToastMsg}
                customer={orderDetail?.lead?.customer}
                setshowPopup={setSubmitShiftingOrderPopup}
                email={orderDetail?.ocLinkSentAtList?.join(', ').toString()}
                setOTPVerification={(verified) => {
                  if (verified) {
                    submitOrder();
                    // handleOrderSubmit();
                  }
                }}
                orderStatus={orderDetail?.orderStatus}
                fetchOrder={fetchOrder}
                isOrderConfirmation={isOrderConfirmation && isOrderConfirmationUrl()}
              />
            )}
            {showNeedAssistPopup && (
              <CancelModal
                title="Reason for Need Assistance"
                label="Reason for assistance"
                subTitle=""
                setshowPopup={setShowNeedAssistPopup}
                onSubmit={handleNeedAssistSubmit}
                loading={loading}
                leadData={leadData}
              />
            )}
            <main className={showThankYouPage || showCancelPage || orderDetail.orderStatus === ORDER_STATUS.OV_REJECTED ? '' : `upgrade-main-section`}>
              {loading && <LoaderComponent />}
              {!loading && !showThankYouPage && !showCancelPage && Object.keys(orderDetail).length > 1 && orderDetail.orderStatus === ORDER_STATUS.OV_REJECTED && (
                <OvRejection orderDetail={orderDetail}></OvRejection>
              )}

              {/* {(isOrderConfirmation || isOrderConfirmationUrl()) && !showThankYouPage && (
                <OrderKycComponent
                  orderDetail={orderDetail}
                  isOrderLoaded={isOrderLoaded}
                  setFormStatus={setFormStatus}
                  setFormData={setFormData}
                  updateOrder={updateOrder}
                  showBillingDetails={showBillingDetails}
                  setShowBillingDetails={setShowBillingDetails}
                  isOrderConfirmation={isOrderConfirmation}
                />
              )} */}

              {/* {(isOrderConfirmation || isOrderConfirmationUrl()) && showThankYouPage && (
                <ThankYouPage leadData={leadData} orderDetail={orderDetail} showCancelPage={showCancelPage} />
              )} */}

              {!loading && userType === USER_TYPE.CUSTOMER && (
                <CustomerJourney
                  leadData={leadData}
                  setLeadData={setLeadData}
                  orderDetail={orderDetail}
                  isOrderLoaded={isOrderLoaded}
                  formStatus={formStatus}
                  setFormStatus={setFormStatus}
                  formData={formData}
                  setFormData={setFormData}
                  updateOrder={updateOrder}
                  pnqFormOpen={pnqFormOpen}
                  setIsPnqFormOpen={setIsPnqFormOpen}
                  poFormOpen={poFormOpen}
                  setPoFormOpen={setPoFormOpen}
                  createLead={createLead}
                  setErrors={setErrors}
                  errors={errors}
                  submitClicked={submitClicked}
                  contactList={contactList}
                  setContactList={setContactList}
                  selectedContact={selectedContact}
                  setSelectedContact={setSelectedContact}
                  siteInCharge={siteInCharge}
                  setSiteInCharge={setSiteInCharge}
                  selectedBandwidth={selectedBandwidth}
                  setSelectedBandwidth={setSelectedBandwidth}
                  selectedServiceType={selectedServiceType}
                  setSelectedServiceType={setSelectedServiceType}
                  selectedCpe={selectedCpe}
                  setSelectedCpe={setSelectedCpe}
                  selectedCpeSpecification={selectedCpeSpecification}
                  setSelectedCpeSpecification={setSelectedCpeSpecification}
                  selectedContractPeriod={selectedContractPeriod}
                  setSelectedContractPeriod={setSelectedContractPeriod}
                  setSelectedHardwareType={setSelectedHardwareType}
                  showNeedAssistPopup={showNeedAssistPopup}
                  setShowNeedAssistPopup={setShowNeedAssistPopup}
                  createOrder={createOrder}
                  showThankYouPage={showThankYouPage}
                  setShowThankYouPage={setShowThankYouPage}
                  showCancelPage={showCancelPage}
                  blockJourney={blockJourney}
                  setBlockJourney={setBlockJourney}
                  setLowerPriceBw={setLowerPriceBw}
                  lowerPriceBw={lowerPriceBw}
                  selectedPrimaryMedia={selectedPrimaryMedia}
                  setSelectedPrimaryMedia={setSelectedPrimaryMedia}
                  loading={loading}
                  checkErrors={checkErrors}
                  onSubmitClick={onSubmitClick}
                  onCancelClick={onCancelClick}
                  isSubmitDisabled={isSubmitDisabled}
                  isCancelDisabled={isCancelDisabled}
                  checkShiftingFeasibility={checkShiftingFeasibility}
                  setShowBillingDetails={setShowBillingDetails}
                  showBillingDetails={showBillingDetails}
                  cancelPnQLead={cancelPnQLead}
                  isOrderConfirmation={isOrderConfirmation}
                />
              )}

              {!loading && userType === USER_TYPE.KAM && (
                <KamJourney
                  leadData={leadData}
                  setLeadData={setLeadData}
                  pnqFormOpen={pnqFormOpen}
                  setIsPnqFormOpen={setIsPnqFormOpen}
                  setErrors={setErrors}
                  errors={errors}
                  submitClicked={submitClicked}
                  contactList={contactList}
                  setContactList={setContactList}
                  selectedContact={selectedContact}
                  setSelectedContact={setSelectedContact}
                  siteInCharge={siteInCharge}
                  setSiteInCharge={setSiteInCharge}
                  selectedBandwidth={selectedBandwidth}
                  setSelectedBandwidth={setSelectedBandwidth}
                  selectedServiceType={selectedServiceType}
                  setSelectedServiceType={setSelectedServiceType}
                  setSelectedHardwareType={setSelectedHardwareType}
                  selectedCpe={selectedCpe}
                  setSelectedCpe={setSelectedCpe}
                  selectedCpeSpecification={selectedCpeSpecification}
                  setSelectedCpeSpecification={setSelectedCpeSpecification}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  selectedContractPeriod={selectedContractPeriod}
                  setSelectedContractPeriod={setSelectedContractPeriod}
                  rentalCost={rentalCost}
                  setRentalCost={setRentalCost}
                  otcCost={otcCost}
                  setOtcCost={setOtcCost}
                  createLead={createLead}
                  commentText={commentText}
                  setCommentText={setCommentText}
                  attachments={attachments}
                  setAttachment={setAttachment}
                  setLowerPriceBw={setLowerPriceBw}
                  showCancelPage={showCancelPage}
                  selectedPrimaryMedia={selectedPrimaryMedia}
                  setSelectedPrimaryMedia={setSelectedPrimaryMedia}
                  loading={loading}
                  checkErrors={checkErrors}
                  onSubmitClick={onSubmitClick}
                  onCancelClick={onCancelClick}
                  isSubmitDisabled={isSubmitDisabled}
                  isCancelDisabled={isCancelDisabled}
                  checkShiftingFeasibility={checkShiftingFeasibility}
                  isOrderConfirmation={isOrderConfirmation}
                />
              )}
            </main>
            {showFooter() && (
              <FooterComponent
                leadData={getUpdatedLeadData()}
                setLeadData={setLeadData}
                formData={formData}
                setShowCancelPopup={setShowCancelPopup}
                pnqFormOpen={pnqFormOpen}
                poFormOpen={poFormOpen}
                setIsPnqFormOpen={setIsPnqFormOpen}
                setConfirmOrderPopup={setConfirmOrderPopup}
                checkFeasibility={checkFeasibility}
                setShowSubmitOrderPopup={setShowSubmitOrderPopup}
                loading={loading}
                setErrors={setErrors}
                errors={errors}
                setSubmitClicked={setSubmitClicked}
                // setConfirmPricingPopup={setConfirmPricingPopup}
                setConfirmPricingKamPopup={setConfirmPricingKamPopup}
                submitLeadCustomer={submitLeadCustomer}
                submitLeadKam={submitLeadKam}
                updateLead={updateLead}
                activeTab={activeTab}
                selectedServiceType={selectedServiceType}
                selectedBandwidth={selectedBandwidth}
                blockJourney={blockJourney}
                lowerPriceBw={lowerPriceBw}
                selectedPrimaryMedia={selectedPrimaryMedia}
                orderDetail={orderDetail}
                onSubmitClick={onProcceedClick}
                isSubmitDisabled={isSubmitDisabled}
                isCancelDisabled={isCancelDisabled}
              />
            )}
          </div>
        </OutsideAlerter>
      </CONTEXT.Provider>
    </Fragment>
  );
});

export default SingleSiteUpgrade;
